const FieldDescription = ({ description }: { description: string }) => {
  if (!description) {
    return null;
  }
  const descriptionsList = description?.split(', ');

  return descriptionsList.map((value, i) => (
    <span key={value}>
      {value}
      {i !== descriptionsList.length - 1 && ', '}
    </span>
  ));
};

export default FieldDescription;
